export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.ed37bc60.woff2";